import { Helmet } from 'react-helmet-async';

export function SEO({ 
  title, 
  description, 
  keywords,
  ogImage = "https://switchyourvendor.com/og-image.jpg",
  canonical,
  type = "website"
}) {
  const siteUrl = "https://switchyourvendor.com";
  const fullTitle = title ? `${title} | SwitchYourVendor` : "SwitchYourVendor | Vendor Management Platform in India";
  const fullCanonical = canonical || window.location.href;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="SwitchYourVendor" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullCanonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="SwitchYourVendor" />
    </Helmet>
  );
}
